import React from 'react';
import { TRIGGER_TYPES } from '../../../config/api';

// Descriptions for trigger types
const TRIGGER_DESCRIPTIONS = {
  PRICE_CROSSOVER_TRENDLINE: 'Price moves from below to above',
  PRICE_CROSSUNDER_TRENDLINE: 'Price moves from above to below',
  PRICE_TOUCHED_TREND_LINE: 'Price touches the trend line',
};

/**
 * TriggerTypeSelector - Dropdown for selecting trend line trigger types
 */
const TriggerTypeSelector = ({
  value,
  onChange,
  error,
  disabled = false,
  required = false,
  label = 'Trigger When',
  rulesSchema = null,
}) => {
  const handleChange = (e) => {
    onChange(e.target.value);
  };

  // Build trigger types from API schema or fallback to constants
  let triggerTypes;
  if (rulesSchema?.ruleTypes) {
    triggerTypes = rulesSchema.ruleTypes.map(rt => ({
      key: rt.name,
      label: rt.description,
    }));
  } else {
    triggerTypes = Object.entries(TRIGGER_TYPES).map(([key, { label: triggerLabel }]) => ({
      key,
      label: triggerLabel,
    }));
  }

  return (
    <div className="fieldset w-full">
      <label className="label">
        <span className="text-sm">{label}{required && <span className="text-error">*</span>}</span>
      </label>
      <select
        className={`select select w-full ${error ? 'select-error' : ''}`}
        value={value || ''}
        onChange={handleChange}
        disabled={disabled}
        required={required}
      >
        <option value="" disabled>Select trigger condition</option>
        {triggerTypes.map(({ key, label: triggerLabel }) => (
          <option key={key} value={key}>
            {triggerLabel} {TRIGGER_DESCRIPTIONS[key] && `- ${TRIGGER_DESCRIPTIONS[key]}`}
          </option>
        ))}
      </select>
      {error && <label className="label"><span className="text-xs text-base-content/60 text-error">{error}</span></label>}
    </div>
  );
};

export default TriggerTypeSelector;
